import { cn } from "@/lib/library";
import { Star, SwatchBook, Tag } from "lucide-react";

export function SaleBadge({ className }: { className?: string }) {
    return (
        <div
            className={cn(
                "absolute -top-0 left-0 z-20 flex flex-row items-center gap-1 rounded-br-md bg-emerald-500 p-1 text-xs text-white",
                className
            )}
        >
            <Tag size={10} />
            Sale
        </div>
    );
}

export function SampleBadge({ className }: { className?: string }) {
    return (
        <div
            className={cn(
                "absolute -top-0 left-0 z-20 flex flex-row items-center gap-1 rounded-br-md bg-violet-600 p-1 text-xs text-white",
                className
            )}
        >
            <SwatchBook size={10} />
            Sample
        </div>
    );
}

export function NewBadge({ className }: { className?: string }) {
    return (
        <div
            className={cn(
                "absolute -top-0 left-0 z-20 flex flex-row items-center gap-1 rounded-br-md bg-blue-500 p-1 text-xs text-white",
                className
            )}
        >
            <Star size={10} />
            New
        </div>
    );
}
